import React from 'react';
import { KPIList, Header, KPIListItem, DateRange } from '../shared';
import KPILoader from 'components/utility/ContentLoader/KPILoader/KPILoader';
import KeyValueGroup from 'components/base/KeyValueGroup/KeyValueGroup';

import useDateRangeKPI from 'hooks/useDateRangeKPI';
import formatDate from 'helpers/formatDate';

interface IPlaylistCompareKPIProps {
  mappedPlaylistData: any;
  dataColors: string[];
  compareMode: any;
  isMobileView: boolean;
}

const PlaylistCompareKPI: React.FC<IPlaylistCompareKPIProps> = (props) => {
  const { mappedPlaylistData, dataColors, compareMode, isMobileView } = props;

  const [thisWeekToDate] = useDateRangeKPI('playlist');

  const playlistThisWeekToDateKeyValueGroupItems = mappedPlaylistData
    ? [
        {
          label: 'Streams',
          metric: mappedPlaylistData?.playlist_stream_count_this_week_to_date,
        },
        {
          label: 'Previous',
          metric: mappedPlaylistData?.playlist_stream_count_last_week_to_date,
        },
        {
          label: 'Change',
          metric: mappedPlaylistData?.playlist_stream_wow_in_progress,
        },
      ]
    : [];

  const playlistCountSkiprateThisWeekToDateKeyValueGroupItems = mappedPlaylistData
    ? [
        {
          label: 'Playlist count',
          metric: mappedPlaylistData?.playlist_count,
        },
        {
          label: 'Skip rate',
          metric: mappedPlaylistData?.skiprate_this_week_to_date,
        },
      ]
    : [];

  return (
    <KPIList>
      <KPIListItem>
        <Header marginBottom={isMobileView && '-1.5em'}>
          {`This Week ${!isMobileView ? 'to Date' : ''}`}
          {thisWeekToDate && (
            <DateRange>
              {`${formatDate(thisWeekToDate?.startDate, 'day', true)} 
              - ${formatDate(thisWeekToDate?.endDate, 'day', true)}`}
            </DateRange>
          )}
        </Header>
        {!mappedPlaylistData && <KPILoader showChange showPrevious />}
        {mappedPlaylistData && (
          <KeyValueGroup
            items={playlistThisWeekToDateKeyValueGroupItems}
            dataColors={dataColors}
            compareMode={compareMode}
            isMobileView={isMobileView}
            showCyAttr
            newDesign
            showColumn
          />
        )}
      </KPIListItem>
      <KPIListItem hasNoHeader>
        {!mappedPlaylistData && <KPILoader />}
        {mappedPlaylistData && (
          <KeyValueGroup
            items={playlistCountSkiprateThisWeekToDateKeyValueGroupItems}
            dataColors={dataColors}
            compareMode={compareMode}
            isMobileView={isMobileView}
            showCyAttr
            newDesign
            showColumn
          />
        )}
      </KPIListItem>
    </KPIList>
  );
};

export default PlaylistCompareKPI;
